import slugify from 'slugify';

import { type Hco } from '@/core/graphql/generated/types';

type Props = {
	name: Hco['hcoNameCda_V'];
	id: Hco['vid_V'];
	tab?: string;
};

export const hcoUrl = ({ name, id, tab = '' }: Props): string => {
	if (!name || !id) {
		return '';
	}

	const trimmedName = name.trim();
	const trimmedId = id.trim();
	const trimmedTab = tab.trim();

	const baseSlug = slugify(trimmedName, {
		replacement: '-', // Default to dash replacement
		lower: false, // Ensure slug is not in lowercase as IDs are case-sensitive
		strict: false, // Preserve non-ASCII letters (e.g. Hangul, CJK)
		remove: /[^\p{L}\p{N}\s-]/gu // Strip punctuation/symbols, keep any-script letters/digits
	});

	return trimmedTab
		? `${baseSlug}-${trimmedId}/${trimmedTab}`
		: `${baseSlug}-${trimmedId}`;
};
